export default __webpack_public_path__ + "static/media/Background 5_00008.df7db3d4.png";